@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.filter-dropdown-button,
.filter-dropdown-button button {
  width: 100%;
  height: 40px;
}

.form-criteria-section {
  display: flex;
  flex-direction: column;
  padding: 0 10px 10px;

  > * {
    margin-top: 10px;
  }
}

.date-picker {
  width: 100%;
}

.free-text-input {
  width: 100%;
}

.number-text-input {
  height: 40px;
  width: 100%;
}

.number-days-input {
  height: 30px;
  width: 200px;
  padding: 0 10px;

  > input {
    width: 40%;
    margin-right: 10px;
  }
}

.free-text-subheader {
  margin-top: 5px;
  font-size: 12px;
  color: @filter-form-render-service--subheader--text-color;
}

.checklist-row {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
